var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "add_circle_FILL0_wght400_GRAD0_opsz48",
    d: "M14.075,19a.727.727,0,0,0,.75-.75v-3.4h3.45a.7.7,0,0,0,.513-.212.75.75,0,0,0-.537-1.288H14.825V9.725a.7.7,0,0,0-.212-.512.75.75,0,0,0-1.288.537v3.6h-3.6a.7.7,0,0,0-.513.213A.75.75,0,0,0,9.75,14.85h3.575v3.425a.7.7,0,0,0,.213.513A.728.728,0,0,0,14.075,19ZM14,24a10.143,10.143,0,0,1-3.95-.763A9.679,9.679,0,0,1,4.762,17.95,10.143,10.143,0,0,1,4,14a10.078,10.078,0,0,1,.762-3.925A9.76,9.76,0,0,1,6.875,6.9,9.97,9.97,0,0,1,14,4,9.92,9.92,0,0,1,24,14a9.97,9.97,0,0,1-2.9,7.125,9.76,9.76,0,0,1-3.175,2.112A10.078,10.078,0,0,1,14,24ZM14,14Zm0,8.5A8.183,8.183,0,0,0,20,20a8.183,8.183,0,0,0,2.5-6A8.183,8.183,0,0,0,20,8a8.183,8.183,0,0,0-6-2.5A8.183,8.183,0,0,0,8,8a8.183,8.183,0,0,0-2.5,6A8.183,8.183,0,0,0,8,20,8.183,8.183,0,0,0,14,22.5Z",
    transform: "translate(-4 -4)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/AddIcon.e2b8f77df1e111aa49370f9a39d552b0.svg";
export { ForwardRef as ReactComponent };